/**
 * Pure mapping from the Server's compact SessionUser (what /auth/login and
 * /auth/me return today) to the richer ServerUser the UI renders. Avatar, bio
 * and frame are filled in by UserContext from GET /api/social/me — auth/me
 * does not carry them. Other fields the Server does not yet expose stay empty.
 */

import type { ServerUser, SessionUser } from "@/types/server";

export function mapSessionToServerUser(session: SessionUser): ServerUser {
  return {
    id: session.id,
    wondeSchoolId: session.schoolId,
    legalFirstName: session.forename,
    legalLastName: session.surname,
    chosenName: session.forename,
    email: "",
    formGroup: "",
    upn: "",
    yearGroup: session.yearGroup,
    avatarId: "",
    avatarBorderId: null,
    bio: "",
    behaviorBalance: 0,
    roleBadges: [],
    connectionsCount: 0,
    activeStrikeCount: session.activeStrikeCount ?? 0,
    restrictedMode: session.restrictedMode ?? false,
  };
}
